export const MovedFromLocations = {
  province: 'A Canadian province or territory',
  country: 'Another Country',
};
